<template>
    <div class="page" @scroll="scrollEvent"> 
        <Menu :curName="'全部课程'"/>
        <div class="courseHead">
            <div class="img-box">
                <img :src="courseInfo.display_img" alt/>
            </div>
            <div class="info-box">
                <div class="course-title">
                    <h1>{{courseInfo.name}}</h1> 
                </div>
                <ul>
                    <li>学习人数:{{courseInfo.learn_times}}</li>
                    <li>课程有效期:{{courseInfo.duration}}天</li>
                </ul>
                <div class="price">￥{{(courseInfo.user_sales_price / 100).toFixed(2)}}</div>
            </div>
            <div class="tools">
                <span>微信扫码打开课程</span>
                <div id="weixinShareQrcode" ref="weixinShareQrcode"></div>
            </div>
        </div>
        <div class="course-content">
            <div class="courseTab">
                <ul>
                    <li @click="tab(1)">课程介绍</li>
                    <li @click="tab(2)">课程详情</li> 
                </ul>
            </div>
            <div v-show="tabIndex===1" class="course-desc" v-html="courseInfo.cont">{{courseInfo.cont}}</div>
            <div v-show="tabIndex===2" class="course-list">
                <ul>
                    <li class="li1" v-bind:key="a.id" v-for="a in courseLessons">
                        <span class="s1">{{a.name}}</span>
                        <ul>
                            <li
                                v-bind:key="b.id"
                                v-for="b in a.list"
                                class="li2"
                                @click="showQrCode()"
                            >
                <span
                    :class="(courseInfo.charge_type ==0 || b.is_free == 1 || courseInfo.is_buy == 1)?'iconfont icon-bofang':''"
                >
                  {{b.name}}
                  <span
                      v-if="(courseInfo.charge_type ==0 || b.is_free == 1 || courseInfo.is_buy == 1)"
                      style="color:red;"
                  >[免费]</span>
                </span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
  
            <!--推荐课程-->
            <div v-if="recommedCourseArr.length >0" class="recommend">
                <div class="title">其他推荐课程</div>
                <CourseList :list="recommedCourseArr" :keyStr="'recommedCourse'"/>
            </div> 
        </div>

        <el-dialog title="微信扫码打开课程" :visible.sync="dialogVisible" :top="'25vh'" :center="true" style="width:480px;margin:0 auto;">
            <div class="dialog-box" style="display:flex;flex-direction:row;justify-content:center;align-item:center;">
                <div id="weixinShareQrcode2" ref="weixinShareQrcode2"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Menu from "@/components/Menu.vue";
    import CourseList from "@/components/CourseList.vue";
    import {courseById, courseLessons, recommendCourse} from "@/api/course.js";
    import QRCode from "qrcodejs2";

    export default { 
        data() {
            return {
                courseInfo: {},
                tabIndex: 1, 
                recommedCourseArr: [], //推荐课程
                courseLessons: [], //课程章节
                page: 1, //评论的页码
                pageSize: 10, //评论每页显示的数量
                noMore: false,
                loading: false,
                dialogVisible:false,
                qrCode:null,
            };
        },
        components: {
            Menu,
            CourseList
        },
        mounted() {
            this.loadData(this.$route.params.id);
        },
        methods: {
            showQrCode(){
                this.dialogVisible = true;

                this.$nextTick(()=>{
                    if(this.qrCode == null){
                        this.qrCode = new QRCode(this.$refs["weixinShareQrcode2"], {
                            text: 'http://bojixt.com/bjxtmobile/'+this.$route.path,
                            width: 150,
                            height: 150,
                            colorDark: "#000000",
                            colorLight: "#ffffff",
                            correctLevel: QRCode.CorrectLevel.H
                        });
                    }
                })
            },
            loadData(id) {
                courseById(id).then(resp => {
                    if (resp != -1) {
                        this.courseInfo = resp;
                         new QRCode(this.$refs["weixinShareQrcode"], {
                            text: 'https://h5.qishanzy.com/#/pages/course/detail?id='+id,
                            width: 150,
                            height: 150,
                            colorDark: "#000000",
                            colorLight: "#ffffff",
                            correctLevel: QRCode.CorrectLevel.H
                        }); 
                    }
                });
                courseLessons(id).then(resp => {
                    if (resp != -1) {
                        this.courseLessons = resp;
                    }
                });
                //加载课程推荐
                recommendCourse(id).then(resp => {
                    if (resp != -1) {
                        this.recommedCourseArr = resp;
                    }
                })
            }, 
            //视频切换
            tab: function (index) {
                this.tabIndex = index;
            },  
            scrollEvent: function (e) {
               
            }
        },
        computed: {}
    };
</script>

<style lang="scss" scoped>
    //课程头部内容信息
    .courseHead {
        width: 1200px;
        margin: 0 auto;
        padding: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .img-box {
            background: #efefef;
            height: 210px;
            width: 372px;
            border-radius: 10px;overflow: hidden;

            img {
                width: 100%;
            }
        }

        .info-box {
            flex: 1;
            margin-left: 30px;
            display: flex;
            flex-direction: column;
            align-content: space-between;
            justify-content: flex-start;

            .course-title {
                display: flex;
                flex-direction: row;
                align-content: space-between;
                margin-bottom: 20px;

                h1 {
                    flex: 1;
                } 
            }

            ul {
                margin-bottom: 20px;

                li {
                    float: left;
                    margin-right: 20px;
                    color: #717171;
                    font-size: 1.6em;
                }
            }

            .price {
                clear: both;
                color: #f92626;
                font-size: 2.4em;
                font-weight: bold;
                margin-bottom: 20px;
            }
        }

        .tools {
            color: #717171;
            display: flex;
            flex-direction: column;justify-content: center;align-content: center;justify-items: center;text-align: center;
            span{
                font-size: 16px;margin-bottom: 10px;
            }
            div{
                width:150px;height: 150px;
            }
        }
    }

    //课程详细内容信息
    .course-content {
        width: 1200px;
        margin: 0 auto;
        border-top: 1px solid #e4e4e4;
        border-bottom: 1px solid #e4e4e4;

        .courseTab {
            height: 60px;
            line-height: 60px;

            li {
                float: left;
                padding: 0 30px;
                font-size: 1.8em;
            }

            li:hover {
                color: #313131;
                cursor: pointer;
            }
        }

        .course-desc,
        .course-list{
            font-size: 1.4em;
            clear: both;
            padding: 30px 0;
            color: #3a3a3a;
        }

        course-desc {
            padding: 30px 15px;
        }

        .course-list {
            li {
                padding: 10px 30px;
                font-size: 1.4em;
                cursor: pointer;
            }

            .li1 {
                display: block;
                width: 100%;

                .s1 {
                    font-size: 15px;
                    color: #383838;
                }

                .li2 {
                    display: block;
                    width: 100%;
                    color: #7e7e7e;

                    span {
                        padding-left: 3px;
                        font-size: 14px;
                    }
                }
            }
        }
    } 

    //推荐课程
    .recommend {
        width: 1200px;
        margin: 0 auto;
        margin-bottom: 40px;

        .title {
            font-size: 1.8em;
            padding: 20px;
        }
    }
</style>
